module.exports = __webpack_public_path__ + "files/4c8d95c0c7755028acdd2a526e89bbf1.png";